import { componentStyles } from "./modal-screen.scss";
import CloseIcon from "static/svg/white-close-circle.svg";
import PictureComponent from "/components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import { SM } from "constants/sizes";
import Tag from "segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/product-cards/product-card/tag/tag";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import classnames from "classnames";

const modalScreen = (props) => {
  const { beforeSubmitCallback, closeProductModal, product, translate } = props;
  const {
    useCases,
    productType,
    useCasesTagesTextColor,
    useCasesTagsBackgroundColor,
    departments,
    productModalImage,
    modalTitle,
    modalSubTitle,
    logoImageV2
  } = product;

  const renderCloseIcon = () => {
    return (
      <div className="product-close">
        <div className="close-wrapper" onClick={closeProductModal}>
          <div className="close-text">{translate("firstFoldWithProducts.Close")}</div>
          <CloseIcon className="close-icon" />
        </div>
      </div>
    );
  };

  return (
    <div
      className="modal-screen"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {renderCloseIcon()}
      <div className="modal-screen-content">
        <div className="left-section">
          <div className="logo-image">
            <PictureComponent src={logoImageV2} />
          </div>
          <div className="title-wrapper">
            <Title title={modalTitle} />
          </div>
          <div className="subtitle-wrapper">
            <Paragraph body={modalSubTitle} />
          </div>

          <div className="card-use-cases-wrapper">
            <div className="card-use-cases">
              {useCases?.map((useCase, index) => (
                <Tag
                  key={index}
                  {...useCase}
                  invertColors={true}
                  useCasesTagesTextColor={useCasesTagesTextColor}
                  useCasesTagsBackgroundColor={useCasesTagsBackgroundColor}
                  productType={productType}
                />
              ))}
            </div>
          </div>
          <div className="ideal-for">
            <div className="departments-title">{translate("firstFoldWithProducts.Card.idealFor")}</div>
            <div className="card-departments">
              {departments?.map((department, index) => (
                <div className="department" key={index} {...department}>
                  {department?.text}
                  {index !== departments.length - 1 && <span className="comma"> |</span>}
                </div>
              ))}
            </div>
          </div>
          <div className={classnames("button-wrapper", productType)}>
            <SignupButton
              withButtonArrow={true}
              beforeSubmitCallback={() => beforeSubmitCallback(productType)}
              skipUpdateCluster={true}
              signupProductId={productType}
              extraData={{ selectedProduct: productType }}
            />
          </div>
        </div>
        <div className="right-section">
          <PictureComponent src={productModalImage} />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default modalScreen;
